// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MangoHubGetPatientInfo {
    'firstName': string;
    'lastName': string;
    'hasPatientConsent': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MangoHubGetPatientInfo>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "hasPatientConsent",
            "baseName": "hasPatientConsent",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return MangoHubGetPatientInfo.attributeTypeMap;
    }
}
